import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export default ({ prefill }) => {
  const intl = useIntl();
  useEffect(() => {
    let timer = setTimeout(() => {
      window.location.href = `https://minigametw.newworldclub.com.hk/?utm_source=${
        intl.locale === "en" ? "Online_RSVP_en" : "Online_RSVP"
      }&utm_medium=Others&prefill=${encodeURIComponent(
        prefill
      )}&source=rsvp&utm_id=2010098`;
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [prefill]);
  return (
    <div className="h-full flex items-center justify-center text-xs text-center text-white">
      <div>
        <p className="mb-6 text-base font-bold">
          <FormattedMessage id="result.redirect.message" />
        </p>
      </div>
    </div>
  );
};
